import { DataAnalysis } from '../../models';
import http, { HttpSuccessOrErrorType } from '../http';

export default {
    // 餐馆菜品分析（时间段）：销量前十名菜品（总数量、总金额、在所有菜品的整体占比）
    async get_data_analysis_sw2p5_restaurant_dish(params: { string_id: string, start?: string, end?: string }): Promise<HttpSuccessOrErrorType<Array<DataAnalysis>>> {
        const { string_id, ...rest } = params;
        return await http.get(`/data-analysis-sw2p5/restaurant-dish/${string_id}`, {
            params: {
                ...rest
            }
        })
    },
    //     根据传入时间段查询历史数据(历史取消)
    async get_data_analysis_sw2p5_history_cancelled_period(params: { string_id: string, start?: string, end?: string }): Promise<HttpSuccessOrErrorType<Array<DataAnalysis>>> {
        const { string_id, ...rest } = params;
        return await http.get(`/data-analysis-sw2p5/history-cancelled/period/${string_id}`, {
            params: {
                ...rest
            }
        })
    },
    //  根据传入时间段查询历史数据（人数，桌台数 之类）
    async get_data_analysis_sw2p5_restaurant_history_period(params: { string_id: string, start?: string, end?: string }): Promise<HttpSuccessOrErrorType<Array<DataAnalysis>>> {
        const { string_id, ...rest } = params;
        return await http.get(`/data-analysis-sw2p5/history/period/${string_id}`, {
            params: {
                ...rest
            }
        })
    },
    //    根据传入时间段查询历史退菜数据
    async get_data_analysis_sw2p5_history_cancelled_dish_period(params: { string_id: string, start?: string, end?: string }): Promise<HttpSuccessOrErrorType<Array<DataAnalysis>>> {
        const { string_id, ...rest } = params;
        return await http.get(`/data-analysis-sw2p5/history-cancelled/dish/period/${string_id}`, {
            params: {
                ...rest
            }
        })
    },
    //    根据传入时间段查询敏感记录信息
    async get_data_analysis_sw2p5_critical_operation_period(params: { string_id: string, start?: string, end?: string }): Promise<HttpSuccessOrErrorType<Array<DataAnalysis>>> {
        const { string_id, ...rest } = params;
        return await http.get(`/data-analysis-sw2p5/critical-operation/period/${string_id}`, {
            params: {
                ...rest
            }
        })
    },
    //  餐馆额外费用分析
    async get_data_analysis_sw2p5_restaurant_service(params: { string_id: string, start?: string, end?: string }): Promise<HttpSuccessOrErrorType<Array<DataAnalysis>>> {
        const { string_id, ...rest } = params;
        return await http.get(`/data-analysis-sw2p5/restaurant-service/${string_id}`, {
            params: {
                ...rest
            }
        })
    },
    // 菜品出菜效率分析
    async get_data_analysis_sw2p5_efficiency_period(params: { string_id: string, start?: string, end?: string }): Promise<HttpSuccessOrErrorType<Array<DataAnalysis>>> {
        const { string_id, ...rest } = params;
        return await http.get(`/data-analysis-sw2p5/efficiency/period/${string_id}`, {
            params: {
                ...rest
            }
        })
    },
    // 刷新
    async get_data_analysis_sw2p5_refresh(params: { string_id: string, start?: string, end?: string }): Promise<HttpSuccessOrErrorType<Array<DataAnalysis>>> {
        const { string_id, ...rest } = params;
        return await http.get(`/data-analysis-sw2p5/${string_id}/refresh`, {
            params: {
                ...rest
            }
        })
    },

    // 餐馆即时运营信息
    async get_data_analysis_sw2p5_current_data(params: { string_id: string }): Promise<HttpSuccessOrErrorType<Array<DataAnalysis>>> {
        const { string_id } = params;
        return await http.get(`/data-analysis-sw2p5/current-data/${string_id}`)
    },
}